import React from "react";
import { lightGrey } from "../theme";

const SectionContainer = props => {
    const { dark, children, style } = props;
    return (
        <div style={{ padding: "2rem 4rem 0rem", background: dark ? lightGrey : "fff", ...style }}>
            <Container>{children}</Container>
        </div>
    );
};

const Container = props => (
    <div style={{ maxWidth: "1200px", margin: "0 auto" }}>{props.children}</div>
);

export { SectionContainer, Container };
